import { useEffect } from 'react';

export function usePopup(closeModal) {
  useEffect(() => {
    document.body.style.overflow = 'hidden';

    function closeOnEsc(e) {
      if(e.key !== 'Escape') {
        return;
      }

      closeModal(e);
    }

    document.addEventListener('keydown', closeOnEsc);

    return () => {
      document.body.style.overflow = 'auto';
      document.removeEventListener('keydown', closeOnEsc);
    };
  });
}
